import { render, staticRenderFns } from "./NewTemplateList.vue?vue&type=template&id=0472b79c&scoped=true&"
import script from "./NewTemplateList.vue?vue&type=script&lang=js&"
export * from "./NewTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./NewTemplateList.vue?vue&type=style&index=0&id=0472b79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472b79c",
  null
  
)

export default component.exports